import { Injectable } from "@angular/core";
import { PurchaseData } from "../shared";
import { ModalService } from "@bhtp-client-web/component";
import { BhtpBaseService, ApiQuoteResponse } from "@bhtp-client-api/base";
import { Http, RequestOptions } from "@angular/http";
import { GatewayErrorResponse } from "../shared/models/agents-gateway/errors/gateway-error-reesponse.model";
import { GWCreateInsuredEventRequest } from "../shared/models/agents-gateway/save-quote/gw-create-insured-event-request.model";
import { GWUpdateInsuredEventRequest } from "../shared/models/agents-gateway/save-quote/gw-update-insured-event-request.model";
import { GWInsuredEvent } from "../shared/models/agents-gateway/save-quote/gw-insured-event.model";
import { InsuredEventMapperV2 } from "../shared/helpers/insured-event.mapper-v2";
import { GWCreateInsuredEventResponse } from "../shared/models/agents-gateway/save-quote/gw-create-insured-event-response.model";
import { GWUpdateInsuredEventResponse } from "../shared/models/agents-gateway/save-quote/gw-update-insured-event-response.model";
import { ApiDocument } from "../shared/models/agents-gateway/documents/api-document.model";
import { PresignedDownloadRequest } from "../shared/models/agents-gateway/documents/presigned-download-request.model";
import { PresignedDownloadResponse } from "../shared/models/agents-gateway/documents/presigned-download-response.model";
import { CommissionableResponse } from "../shared/models/agents-gateway/commissionable/commissionable-response.model";
import { CommissionableRequest } from "../shared/models/agents-gateway/commissionable/commissionable-request.model";

@Injectable()
export class PolicyDocumentService extends BhtpBaseService {
    constructor(private http: Http, private insuredEventMapper: InsuredEventMapperV2) {
        super();
    }

    public async getPolicyDocument(policyNumber: string): Promise<ApiDocument> {
        let path: string = this.getFullUrl(`/policy/document/${policyNumber}`);
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        try {
            let response: any = await this.http.get(path, options).toPromise();
            return JSON.parse(response._body);
        } catch (err) {
            this.handleGatewayError(err);
        }
    }

    public async getPresignedPolicyDocument(policyNumber: string, req: PresignedDownloadRequest): Promise<PresignedDownloadResponse> {
        let path: string = this.getFullUrl(`/policy/presign/${policyNumber}`);
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        try {
            let response: any = await this.http.post(path, req, options).toPromise();
            return JSON.parse(response._body);
        } catch (err) {
            this.handleGatewayError(err);
        }
    }

    public async checkIfCommissionable(req: CommissionableRequest): Promise<CommissionableResponse> {
        let path: string = this.getFullUrl('/policy/commissionable');
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);

        try {
            let response: any = await this.http.post(path, req, options).toPromise();
            return JSON.parse(response._body);
        }
        catch (err) {
            this.handleGatewayError(err);
        }
    }

    private handleGatewayError(err: any) {
        let errorToThrow: GatewayErrorResponse;
        const body = err._body;
        if (body) {
            errorToThrow = JSON.parse(body);
        }
        else {
            errorToThrow = {
                message: 'Unknown Error',
                name: 'UNKNOWN_ERROR',
                validationMessages: []
            };
        }
        throw errorToThrow;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy/policy-document.service.ts